import React, { useEffect, useState, useRef } from "react"
import { useTranslation } from "react-i18next"
import { useFormik } from "formik"
import { useDispatch, useSelector } from "react-redux"
import * as yup from "yup"
import DateTimePicker from "react-datetime-picker"
import { FormControl, InputAdornment, TextField, Button } from "@material-ui/core"
import { makeStyles, useTheme } from "@material-ui/core/styles"
import Simple from "./Simple"
import "react-datetime-picker/dist/DateTimePicker.css"
import "react-calendar/dist/Calendar.css"
import "react-clock/dist/Clock.css"
import CalenderIconSvg from "../../icons/CalenderIconSvg"
import { updateTaggedDate } from "../../../actions/taggedDateActions"
import moment from "moment"

const useStyles = makeStyles((theme) => ({
	root: {
		display: "flex",
		flexWrap: "wrap",
	},
	margin: {
		margin: theme.spacing(2),
	},

	formActions: {
		display: "flex",
		justifyContent: "flex-end",
		flexDirection: "row",
		width: "100%",
		gap: "4px",
		paddingTop: 10,
	},
	formActionsBtn: {
		"&:disabled": {
			backgroundColor: theme.palette.grey[300],
		},
		textTransform: "none",
	},
	textField: {
		width: "327px",
		"& .MuiOutlinedInput-input": {
			paddingLeft: "12px",
			...theme.typography.body2,
		},
		"& fieldset > legend": {
			float: "none",
		},
		"& input[type='text']:focus": {
			boxShadow: "none",
		},
	},
	inputFormControl: {
		padding: "12px 0 24px",
		height: 350,
	},
	taggedDateDialog: {
		"& .MuiDialogTitle-root > h2": {
			...theme.typography.h6,
			fontWeight: theme.typography.fontWeightMedium,
			wordWrap: "break-word",
		},
		"& .MuiDialogContent-root": {
			height: 450,
		},
		"& .react-calendar": {
			//padding: "1px 4px 0px 1px",
		},
		"& .react-datetime-picker": {
			padding: "2px 6px",
		},
		"& .react-datetime-picker__clear-button": {
			display: "none",
		},
		"& .react-datetime-picker__wrapper": {
			border: "none",
			width: 340,
		},
		"& .react-datetime-picker__inputGroup__amPm:focus": {
			backgroundImage: "none",
		},
	},
	formActionsCancelBtn: {
		color: theme.palette.grey["D100"],
		fontSize: theme.typography.fontSize,
		fontWeight: theme.typography.fontWeightMedium,
		textTransform: "none",
		"&:hover": {
			background: "none",
		},
	},
}))

function TaggedDateDialog({ open, title, onClose, tagDatedDialogData }) {
	const theme = useTheme()
	const classes = useStyles(theme)
	const [t] = useTranslation("global")
	const dispatch = useDispatch()
	const [dateTime, setDateTime] = useState(tagDatedDialogData?.tagged_date)
	const [isCalOpen, setIsCalOpen] = useState(false)

	const handleDateTimeChange = (date) => {
		setDateTime(date)
	}

	const handleSubmit = () => {
		if (dateTime) {
			const taggedDate = convertDateStringToObject(dateTime)
			dispatch(updateTaggedDate({ fileId: tagDatedDialogData?.id, taggedDate: taggedDate }))
			onClose()
		}
	}

	const convertDateStringToObject = (dateString) => {
		return moment.utc(dateString).format()
	}

	const taggedDateForm = useFormik({
		initialValues: {
			tagged_date: "",
		},
		onSubmit: handleSubmit,
	})

	const filteredProps = {
		open: open,
		title: title,
		onClose: null,
		dynamicClass: classes.taggedDateDialog,
	}

	useEffect(() => {
		tagDatedDialogData?.tagged_date && setDateTime(convertDateStringToObject(tagDatedDialogData?.tagged_date))
	}, [tagDatedDialogData])

	return (
		<Simple {...filteredProps}>
			<form noValidate autoComplete="off" id="editTaggedDate" onSubmit={taggedDateForm?.handleSubmit}>
				<FormControl className={classes.inputFormControl}>
					<DateTimePicker
						onChange={handleDateTimeChange}
						value={dateTime}
						autoFocus={true}
						isCalendarOpen={true}
						calendarIcon={() => {
							return <CalenderIconSvg />
						}}
						format="dd/MM/y h:mm a"
						amPmAriaLabel="AM/PM"
						shouldCloseWidgets={({ reason, widget }) =>
							!(reason == "select" || reason == "outsideAction") && widget === "calendar"
						}
					/>
				</FormControl>
				<FormControl className={classes.formActions}>
					<Button
						variant="contained"
						color="primary"
						className={classes.formActionsBtn}
						style={{
							padding: "4px 12px",
							background: theme.palette.primary.dark,
							fontWeight: theme.typography.fontWeightMedium,
						}}
						type="submit"
						disabled={!taggedDateForm.isValid}
					>
						{t("taggedDateDialog.updateBtnTxt")}
					</Button>
					<Button
						variant="text"
						className={classes.formActionsCancelBtn}
						onClick={() => {
							onClose()
						}}
					>
						{t("taggedDateDialog.cancelBtnTxt")}
					</Button>
				</FormControl>
			</form>
		</Simple>
	)
}

export default TaggedDateDialog
